import { cn } from "@/lib/utils";

interface BlurTextProps {
	text: string;
	as?: "h1" | "h2" | "h3" | "p" | "span";
	className?: string;
}

export function BlurText({ text, as: Tag = "h1", className }: BlurTextProps) {
	const words = text.split(" ");

	return (
		<Tag className={cn("blur-text", className)}>
			{words.map((word, i) => (
				<span
					key={`${word}-${i}`}
					className="inline-block animate-blur-in opacity-0"
					style={{
						animationDelay: `${i * 80}ms`,
						animationFillMode: "forwards",
					}}
				>
					{word}
					{i < words.length - 1 ? "\u00A0" : ""}
				</span>
			))}
		</Tag>
	);
}
